module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-4-desktop.jpg?v=a3bdf31c";